<template>
  <v-container class="select-category" :class="{ 'disabled': readonly}" fluid justify-center fill-height>
    <page-title :title="$t('survey.select_category.page_title')"></page-title>
    
    <div>
      <h3>{{ $t('survey.select_category.title') }}</h3>
      <v-layout row wrap justify-center>
        
        <v-flex
          v-for="category in categories"
          :key="category.type"
          class="category"
          align-content-center
          justify-content
          xs3
          :class="{'selected': category.type === selected}"
          @click="change(category)"
        >
          <v-layout align-center justify-center column fill-height>
            <h2 class="category-name">{{ category.label }}</h2>
            <div class="lg-radio" :class="{'selected': category.type === selected}">
              <div class="lg-radio-circle">
                <div class="lg-radio-selection">
                </div>
              </div>
            </div>
          </v-layout>
        </v-flex>
        
      </v-layout>
      <div v-if="readonly" class="category-warning">Please contact us to change business category.</div>
    </div>
  </v-container>
</template>

<script>
import filter from 'lodash/filter'
import find from 'lodash/find'
import each from 'lodash/each'
import EventBus from '@/event_bus'

export default {
  name: 'BizCategorySelection',
  props: {
    campaign: Object,
    readonly: {type: Boolean, default: false}
  },
  data: function() {
    return {
      categories: [
        {
          type: 'SAAS',
          label: 'Saas',
          readonly: false
        },
        {
          type: 'ECOMMERCE',
          label: 'Ecommerce',
          readonly: false
        },
        {
          type: 'OTHER',
          label: 'Other',
          readonly: false
        }
      ],
      selected: this.campaign.category
    }
  },
  methods: {
    change: function(category) {
      if (this.readonly && this.selected != category.type) {
        // EventBus.$emit('SHOW_SNACK', { msg: 'You can not change business category once set. Please contact us to change it for you.' })
        return 
      } 
      var vm = this
      vm.selected = category.type
      vm.$emit(
            'change',
            {
              category: category.type
            },
            100
          )
    }
  }
}
</script>

<style lang="stylus">
.select-category {
    padding 0

    &.disabled{
      .category {
        cursor not-allowed
      }
    }
    h3 {
        text-align center
        margin-bottom 40px
        color: $color-primary-light-1
        font-weight: 500;
        font-size: 20px;
    }

    .category {
        height 250px
        min-width 250px
        margin 25px
        border: 1px solid $color-primary-light-8;
        box-sizing: border-box;
        default-box-shadow()
        border-radius: 5px;
        text-align center
        padding 20px
        cursor pointer
        transition all .5s
        &.selected {
          border: 3px solid $color-accent;
          .category-name {
            color: $color-primary
            }
          
          }

        .category-name {
            color: $color-primary-light-1
            margin-bottom 12px
            font-size 18px
        }

        .category-label {
            color: $color-primary-light-1
            margin-bottom 12px
            font-weight 500
            font-size 16px
        }
    }
    .category-warning {
      margin-top 50px
      color $color-primary-light-5
      font-size 16px
      text-align center
    }
}

.lg-radio {
  .lg-radio-circle {
    width : 25px
    height 25px
    background-color #fff
    border 8px solid $color-primary-light-5
    box-sizing border-box
    border-radius: 50%
    transition all .5s
  
  }
  &.selected .lg-radio-circle {
    border 8px solid $color-accent
    }
}
</style>
